// extracted by mini-css-extract-plugin
export default {"wrp":"AddingFolder_wrp__asfNg","title":"AddingFolder_title__RDxMH","form-wrp":"AddingFolder_form-wrp__dJ-mU","item":"AddingFolder_item__jjHwm","button":"AddingFolder_button__CRpgb"};